var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.rgReports),function(report){return _c('rack-group-item',{key:report.id,attrs:{"rg-report":report,"operation-users":_vm.operationUsers,"read-only":_vm.readOnly}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }